import { render, staticRenderFns } from "./PortalBusca.vue?vue&type=template&id=531657b9&"
import script from "./PortalBusca.vue?vue&type=script&lang=js&"
export * from "./PortalBusca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports